<template>
    
    <div class="content">
        <div class="row">
            <div class="col-md-12">
              <router-link :to="{ name: 'odcodp-tambah', params: { page: 'odp' }}" class="btn btn-primary" v-if="myGlobal.RootOnly()">Tambah ODP</router-link>
              <div class="card">
                <div class="card-header card-header-info">
                  <div class="row">
                    <div class="col-md-12">
                      <h4 class="card-title ">ODC</h4>
                    </div>
                    <div class="col-md-6" v-show="false">
                      <h2 class="card-title text-right">{{data.filtered}}</h2>
                    </div>
                  </div>
                </div>
                <div class="card-body">
                  <div class="table-responsive">
                    <table class="table">
                      <thead class=" text-info">
                        <th width="40px">No.</th>
                        <th>Nama</th>
                        <th>Jumlah Port</th>
                        <th>Aksi</th>
                      </thead>
                      <tbody>
                        <tr v-for="(u, index) in theGet.data.List">
                          <td>{{ index+1 }}</td>
                          <td>{{ u.nomor }}</td>
                          <td>{{ u.port }}</td>
                          <td>
                            
                            <button  @click="data.modalHapus = true, data.idHapus = u.id, data.nmHapus = u.nomor" class="btn btn-sm btn-danger" ><i class="material-icons">delete_outline</i></button>

                          </td>
                        </tr>
                        <tr v-if="theGet.data.List == null">
                          <td></td>
                          <td>Tidak ada Data </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            
        </div>

        <!-- MODAL -->
        <div class="modal" tabindex="-1" role="dialog" v-show="data.modalHapus">
            <div class="overlay"></div>
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title">Hapus</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="data.modalHapus = false">
                    <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div class="modal-body">
                    <div class="row">
                      <div class="col-md-12">
                        <p class="text-center">{{"Hapus Pelanggan "+data.nmHapus+" ?"}}</p>
                      </div>
                    </div>
                  </div>
                  <div class="modal-footer">
                    <button type="button" class="btn btn-info" @click="data.modalHapus = false">Tidak</button>
                    <button type="button" class="btn btn-secondary" @click="theGet.hapus();data.modalHapus = false">Ya</button>
                  </div>
              </div>
          </div>
        </div>

    </div>
</template>

<script>
import Vue from 'vue'
import vuejsDatepicker from 'vuejs-datepicker'
import moment from 'moment'

import { url,homePage } from '@/var/var.js'
import VueBarcode from 'vue-barcode';

import { reactive } from '@vue/composition-api'
import myGlobal from '@/globalFunc/myGlobal' 
import inter from '@/globalFunc/Interface' 

Vue.use(moment)

export default {
  name: 'Beranda',
  components: { 

  }, 
  setup() {
    const data = reactive({
      filtered: '',

      bulanNama: '', bulan: '',tahun: '',
      totalAll: 0,

      modalHapus: false,
      idHapus: null,
      nmHapus: null,
      /* modal edit tarif */
    })

    const theGet = {
      data: reactive({
          List: [],
      }),
      datae() {
        //console.log(sessionStorage.getItem('admin'));
        var datax = {
            token: 'TangTung '+sessionStorage.getItem('myToken'),
            page: "ODP"
        };
    
        var apiUrl = inter.ODCODPList();
        myGlobal.call(datax,apiUrl).then(x => {
          //console.log(JSON.stringify(x));
          if (x.status == true) {
              this.data.List = x.data;

          } else {
              //alert(x.pesan);
          }
        })
      },
      hapus() {
        var id = data.idHapus;

        var datax = {
            token: 'TangTung '+sessionStorage.getItem('myToken'),
            id: id
        };
    
        var apiUrl = inter.ODCODPHapus();
        myGlobal.call(datax,apiUrl).then(x => {

          if (x.status == true) {

            this.datae();

            // this.data.List = x.data;

          } else {

            //alert(x.pesan);

          }

        })
      }
    }
    return {
      data, 
      theGet,
      myGlobal
    }
  },
  mounted () {
    document.title = "ODC";

    this.theGet.datae();
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.modal {
	display: inherit;
}
</style>



// WEBPACK FOOTER //
// src/components/odcodp/odp.vue